import { StatusChip } from './StatusChip';

export function TableStatusBlock({
  className,
  color,
  label,
  status,
}: {
  className?: string;
  color?: string;
  label?: string;
  status: string;
}) {
  return (
    <StatusChip className={className} color={color} label={label} status={status} variant="table" />
  );
}
